<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/dealer/orders" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Bestelldetails</h3>
      </div>
    </div>
    <div class="card-body">
      <table class="provider-info-tbl">
        <tr>
          <td><b>Rechnungsnummer</b></td>
          <td>{{ orderData.invoice_no }}</td>
        </tr>
        <tr>
          <td><b>Bestelldatum</b></td>
          <td>{{ orderData.updated_at }}</td>
        </tr>
        <tr>
          <td><b>Kundenname</b></td>
          <td>
            {{
              customerData.company_name
                ? customerData.company_name
                : customerData.first_name + " " + customerData.last_name
            }}
          </td>
        </tr>
        <tr>
          <td><b>E-Mail</b></td>
          <td>{{ customerData.email }}</td>
        </tr>
        <tr>
          <td><b>Telefonnummer</b></td>
          <td>{{ customerData.phone_no }}</td>
        </tr>
        <tr>
          <td><b>Adresse</b></td>
          <td>{{ addressData.address }}</td>
        </tr>
        <tr>
          <td><b>Stadt</b></td>
          <td>{{ addressData.city }}</td>
        </tr>
        <tr>
          <td><b>Postleitzahl</b></td>
          <td>{{ addressData.postcode }}</td>
        </tr>
      </table>
      <v-divider></v-divider>
      <h5 v-if="orderData.discount_detail">Rabatt Informationen</h5>
      <table class="provider-info-tbl" v-if="orderData.discount_detail">
        <tr>
          <td><b>Rabatt-/Gutscheincodes</b></td>
          <td>{{ orderData.discount_detail.discount_code }}</td>
        </tr>
        <tr>
          <td><b>Angebotstyp</b></td>
          <td>
            {{
              orderData.discount_detail.offer_type == "% off"
                ? "Prozentsatz"
                : "Fixer Betrag"
            }}
          </td>
        </tr>
        <tr>
          <td><b>Betrag</b></td>
          <td>{{ orderData.discount_detail.offer_value | priceFormat }}</td>
        </tr>
        <tr>
          <td><b>Rabattbetrag</b></td>
          <td>
            {{ orderData.discount_detail.discount_amount | priceFormat }}
            {{ currencySybmol }}
          </td>
        </tr>
        <tr>
          <td><b>Bezahlung durch</b></td>
          <td>
            {{ orderData.discount_detail.paid_by == "admin" ? "Gustoreich" : "Händler" }}
          </td>
        </tr>
      </table>
      <v-divider></v-divider>
      <div class="product-table">
        <h5>Produkte</h5>
        <table>
          <div class="table-responsive mt-5">
            <v-simple-table class="record-table">
              <thead>
                <tr>
                  <th class="text-center align-middle" width="10%">Seriennummer</th>
                  <th width="35%" class="text-center align-middle">Produktname</th>
                  <th width="30%" class="text-center align-middle">Menge</th>
                  <th class="text-center align-middle" width="10%">Preis pro Einheit</th>
                  <th class="text-center align-middle" width="15%">Preis</th>
                  <th class="text-center align-middle" width="15%">MWSt.</th>
                  <th class="text-center align-middle" width="15%">Lieferspesen</th>
                  <th class="text-center align-middle" width="15%">Review</th>
                  <th class="text-center align-middle">Kommentar</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(product, i) in productData" :key="product.id">
                  <td class="align-middle clickable-td">
                    {{ i + 1 }}
                  </td>
                  <td class="align-middle clickable-td">
                    {{
                      product.product_name.length > 30
                        ? product.product_name.substr(0, 30) + "..."
                        : product.product_name
                    }}
                  </td>
                  <td class="align-middle clickable-td">
                    {{
                      product.quantity +
                      " x " +
                      product.quantity_measure +
                      " " +
                      product.unit
                    }}
                  </td>
                  <td class="align-middle clickable-td">
                    {{ product.unit_price | priceFormat }} {{ currencySybmol }}
                  </td>
                  <td class="align-middle clickable-td">
                    {{ product | dashboardProductTotalQtyPrice }}
                    {{ currencySybmol }}
                  </td>
                  <!-- <td class="align-middle clickable-td">
                    {{ product.vat_amount | priceFormat }} {{ currencySybmol }}
                  </td> -->
                  <td class="align-middle clickable-td">
                    {{ product.mswt | priceFormat }} {{ currencySybmol }}
                    
                  </td>
                  <td class="align-middle clickable-td">
                    {{ product.shipping_amount | priceFormat }}
                    {{ currencySybmol }}
                  </td>
                  <td class="align-middle clickable-td">
                    <v-rating
                      v-if="product.rating && product.rating != ''"
                      v-model="product.rating"
                      background-color="#3d5a80"
                      color="#002c47"
                      size="30"
                      half-increments
                      readonly
                    ></v-rating>
                    <p v-else>-</p>
                  </td>
                  <td class="align-middle clickable-td">
                    <p
                      v-if="product.comment && product.comment != ''"
                      style="margin-top: 15px"
                    >
                      {{
                        product.comment.length > 40
                          ? product.comment.substr(0, 40) + "..."
                          : product.comment
                      }}
                    </p>
                    <p v-else>-</p>
                  </td>
                </tr>
                <!-- <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><b>Gesamt</b></td>
                  <td>
                    <b>{{ transactionDetail.amount }}</b>
                  </td>
                </tr> -->
              </tbody>
            </v-simple-table>

            <table class="provider-info-tbl mt-5">
              <tr>
                <td><b>Lieferspesen gesamt</b></td>
                <td>
                  {{ totalShippingCost | priceFormat }}
                  {{ currencySybmol }}
                </td>
              </tr>
              <tr>
                <td><b>Gesamt</b></td>
                <td>
                  {{ orderData.paid_amount | priceFormat }}
                  {{ currencySybmol }}
                </td>
              </tr>
            </table>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import config from "@/config/app.js";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import providerAPI from "@/api/provider";
Vue.use(Notifications);
export default {
  name: "OrderDetails",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getOrderDetails();
    }
  },
  data() {
    return {
      currencySybmol: config.CURRENCY_SYMBOL,
      orderData: [],
      userData: [],
      productData: [],
      customerData: [],
      addressData: [],
      transactionDetail: [],
      searchNameKey: "",
      searchCategoryKey: "",
      loading_order_data: true,
      totalShippingCost: 0,
    };
  },
  methods: {
    goToDetails(id) {
      this.$router.push({ path: "/dealer/inbox/" + id });
    },
    getOrderDetails() {
      providerAPI
        .getOrderDetails({
          order_id: this.$route.params.id,
          role: this.currentUser.role,
          user_id: this.currentUser.id,
        })
        .then((response) => {
          if (response.status == "success") {
            if (response.valid_user == true) {
              this.orderData = response.data;
              this.productData = response.data.products;
              if (this.productData) {
                this.productData.forEach(element => {
                  if (element.unit_price) {
                    const unitPrice = parseFloat(element.unit_price.replace(',', '.'));
                    const vatAmount = parseFloat(element.vat_amount.replace(',', '.'));
                    const totalprice = unitPrice - vatAmount; 
                    const roundedTotalPrice = totalprice.toFixed(2)
                    element.mswt = roundedTotalPrice.replace(',', '.');
                  } else {
                    element.mswt = '0,00' ;
                  }
                  
                });
              }
              let totalShipping = 0;
              response.data.products.forEach((item) => {
                let value = item.shipping_amount.toString().replace(",", ".");
                totalShipping = totalShipping + parseFloat(value);
              });
              let dealerShipping = response.data.shipping_amount
                .toString()
                .replace(",", ".");
              totalShipping = totalShipping + parseFloat(dealerShipping);
              this.totalShippingCost = totalShipping.toString();
              this.customerData = response.data.customer_data;
              this.addressData = response.data.address_data;
              this.transactionDetail = response.data.transaction_detail;
              this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } else {
              this.$router.push({ name: "provider-orders" });
            }
          } else {
            this.loading_order_data = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.loading_order_data = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}
.product-table {
  width: 100%;
  overflow: auto;
}
.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
  margin: 5px;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>
